var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { applySubscriptionBuff, selectSelectedOfferPage, selectShopAllOffers, selectShopOfferBundles, selectShopOffersFromGroupName, selectSmsOffers, } from "../../../selectors/selectShopInfo";
import { actionModalCloseAll } from "../../modals/actionModal";
import { ModalOverlay } from "../../modals/ModalOverlay";
import { TypeOverlayOpacity } from "../../modals/TypeOverlayOpacity";
import { actionShopRequestPurchase, actionShopSelectOffer } from "../actionShop";
import { Shop } from "./Shop";
var _MenuShop = function (_a) {
    var offers = _a.offers, offerBundles = _a.offerBundles, offerBundleGrowthFund = _a.offerBundleGrowthFund, selectedPage = _a.selectedPage, onBuyClick = _a.onBuyClick, smsOffers = _a.smsOffers, onCloseClick = _a.onCloseClick;
    var offerToOfferWithActions = function (offerProps) { return (__assign({}, offerProps, { onBuyClick: onBuyClick })); };
    var offersWithActions = offers.map(offerToOfferWithActions);
    var offerBundlesWithActions = offerBundles.map(function (bundleOffers) {
        return bundleOffers.map(offerToOfferWithActions);
    });
    var offerBundleGrowthFundWithActions = offerBundleGrowthFund.map(offerToOfferWithActions);
    return (React.createElement(ModalOverlay, { opacityType: TypeOverlayOpacity.Dark, allowClick: false, onCloseOverride: onCloseClick },
        React.createElement(Shop, { offers: offersWithActions, offerBundles: offerBundlesWithActions, offerBundleGrowthFund: offerBundleGrowthFundWithActions, selectedPage: selectedPage, onClose: onCloseClick })));
};
var mapDispatch = function (dispatch) { return ({
    onBuyClick: function (offer, selectedProvider) {
        return dispatch(actionShopRequestPurchase(offer, selectedProvider));
    },
    onCloseClick: function () {
        dispatch(actionShopSelectOffer());
        dispatch(actionModalCloseAll());
    },
}); };
var mapState = function (state) {
    var allOffers = (state.cheats.activeOfferGroup
        ? selectShopOffersFromGroupName(state, state.cheats.activeOfferGroup)
        : selectShopAllOffers(state));
    var filteredOffers = applySubscriptionBuff(state, allOffers).slice();
    var _a = selectShopOfferBundles(state, filteredOffers), offerBundles = _a.offerBundles, offerBundleGrowthFund = _a.offerBundleGrowthFund;
    var selectedPage = selectSelectedOfferPage(state);
    var smsOffers = selectSmsOffers(state);
    return {
        offerBundleGrowthFund: offerBundleGrowthFund,
        offerBundles: offerBundles,
        offers: filteredOffers,
        selectedPage: selectedPage,
        smsOffers: smsOffers,
    };
};
export var MenuShop = connect(mapState, mapDispatch)(_MenuShop);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/MenuShop.tsx
// module id = 2904
// module chunks = 3